class CommentsUtils {

    setThreadLineHeight() {

        function _applyLineHeight() {

            const $this = $(this);
            const $avatar = $this.find("img.comment-author-avatar");
            const firstAvatarTop = $avatar.first().offset().top;
            const lastAvatarTop = $avatar.last().offset().top;

            $this.find("div.thread-line").height(lastAvatarTop - firstAvatarTop);

        }

        const $commentsThreads = $("div.comment-thread");

        setTimeout(function() {
            $commentsThreads.each(_applyLineHeight);
        }, 0);

    }

    saveRangePosition(divId) {

        function _getNodeIndex(n){
            var i=0;
            while(n=n.previousSibling)i++;
            return i
        }

        var range=window.getSelection().getRangeAt(0);
        var sC=range.startContainer,eC=range.endContainer;

        A=[];
        while(sC!==divId[0]){
            A.push(_getNodeIndex(sC));
            sC=sC.parentNode
        }
        B=[];
        while(eC!==divId[0]){
            B.push(_getNodeIndex(eC));
            eC=eC.parentNode
        }

        window.rp={"sC":A,"sO":range.startOffset,"eC":B,"eO":range.endOffset};

    }

    restoreRangePosition(divId) {

        divId[0].focus();
        var sel=window.getSelection(),range=sel.getRangeAt(0);
        var x,C,sC=divId[0],eC=divId[0];

        C=rp.sC;
        x=C.length;

        while(x--)
            sC=sC.childNodes[C[x]];

        C=rp.eC;
        x=C.length;

        while(x--)
            eC=eC.childNodes[C[x]];

        range.setStart(sC,rp.sO);
        range.setEnd(eC,rp.eO);
        sel.removeAllRanges();
        sel.addRange(range)

    }

    insertAtCaret(areaId, text) {
        var txtarea = document.getElementById(areaId);
        var scrollPos = txtarea.scrollTop;
        var strPos = 0;
        var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
            "ff" : (document.selection ? "ie" : false ) );
        if (br == "ie") {
            txtarea.focus();
            var range = document.selection.createRange();
            range.moveStart ('character', -txtarea.value.length);
            strPos = range.text.length;
        }
        else if (br == "ff") strPos = txtarea.selectionStart;

        var front = (txtarea.value).substring(0,strPos);
        var back = (txtarea.value).substring(strPos,txtarea.value.length);
        txtarea.value=front+text+back;
        strPos = strPos + text.length;
        if (br == "ie") {
            txtarea.focus();
            var range = document.selection.createRange();
            range.moveStart ('character', -txtarea.value.length);
            range.moveStart ('character', strPos);
            range.moveEnd ('character', 0);
            range.select();
        }
        else if (br == "ff") {
            txtarea.selectionStart = strPos;
            txtarea.selectionEnd = strPos;
            txtarea.focus();
        }
        txtarea.scrollTop = scrollPos;
    }

}